<template>
  <div id="app">
    <!-- 路由出口：根据当前路由显示不同页面 -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
	min-width:1200px;
	padding:0;
	margin: 0;
	background-color:#EFF0F1 !important;
	overflow: hidden; /* 确保有滚动效果 */
	overflow-y: scroll;
	padding-right:0 !important;
}
p,span{
	word-wrap: break-word;
}
*{
	padding:0;
	margin: 0;
	text-decoration:none;
	list-style:none;
}
a{
	text-decoration: none;
	color:#999999;
}
body::-webkit-scrollbar { /* Chrome, Safari, Opera*/
  width:0px;
  display: none;
}
#app {
}

</style>
